__turbopack_context__.v({
  "articleTile": "category-module-scss-module__HgxnEa__articleTile",
  "bigDesktopPageWidth": "category-module-scss-module__HgxnEa__bigDesktopPageWidth",
  "categoryArticleGrid": "category-module-scss-module__HgxnEa__categoryArticleGrid",
  "desktopPageWidth": "category-module-scss-module__HgxnEa__desktopPageWidth",
  "divider": "category-module-scss-module__HgxnEa__divider",
  "ratgeberCategoryPage": "category-module-scss-module__HgxnEa__ratgeberCategoryPage",
  "root": "category-module-scss-module__HgxnEa__root",
  "roundedImageContainer": "category-module-scss-module__HgxnEa__roundedImageContainer",
  "sanitized": "category-module-scss-module__HgxnEa__sanitized",
  "threeLineEllipse": "category-module-scss-module__HgxnEa__threeLineEllipse",
});
